import React, { useEffect, useState } from "react";
import { Paper, Typography, Box } from "@mui/material";
import axios from '../../utils/axios';
import BarChartIcon from '@mui/icons-material/BarChart';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';

export default function Stats() {
  const [summary, setSummary] = useState({ totalLinks: 0, totalClicks: 0 });
  const [clickData, setClickData] = useState([]);

  useEffect(() => {
    axios.get('/statistics/user').then(res => {
      setSummary(res.data);
    });

    axios.get('/statistics/user/all-clicks').then(res => {

      setClickData(res.data || []);
    });
  }, []);

  // Chuyển đổi clickData để hiển thị biểu đồ
  const transformed = clickData.map(click => ({
    date: new Date(click.clicked_at).toLocaleDateString('vi-VN'),
    count: 1
  }));

  const summaryData = Object.values(transformed.reduce((acc, item) => {
    acc[item.date] = acc[item.date] || { date: item.date, count: 0 };
    acc[item.date].count += 1;
    return acc;
  }, {}));

  return (
    <Paper sx={{ p: 4, borderRadius: 4 }}>
      <Box display="flex" alignItems="center" mb={2} gap={1}>
        <BarChartIcon color="primary" />
        <Typography variant="h5" fontWeight={700}>
          Thống kê cá nhân
        </Typography>
      </Box>

      <Typography color="text.secondary" mb={3}>
        Xem tổng lượt click và số liên kết bạn đã tạo. Dưới đây là biểu đồ thống kê lượt truy cập theo thời gian.
      </Typography>

      <Box display="flex" gap={4} flexWrap="wrap" mb={4}>
        <Paper sx={{ p: 3, minWidth: 140, textAlign: "center", flex: 1 }}>
          <Typography variant="subtitle2">Tổng click</Typography>
          <Typography variant="h4" color="primary">{summary.totalClicks}</Typography>
        </Paper>
        <Paper sx={{ p: 3, minWidth: 140, textAlign: "center", flex: 1 }}>
          <Typography variant="subtitle2">Tổng liên kết</Typography>
          <Typography variant="h4" color="primary">{summary.totalLinks}</Typography>
        </Paper>
      </Box>

      <Box>
        <Typography variant="h6" fontWeight={700} mb={2}>
          Biểu đồ click theo ngày
        </Typography>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={summaryData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Line type="monotone" dataKey="count" stroke="#6366f1" strokeWidth={3} dot={{ r: 4 }} />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
}
